import { render, staticRenderFns } from "./DropdownItemsList.vue?vue&type=template&id=491d1b9a&scoped=true&"
import script from "./DropdownItemsList.vue?vue&type=script&lang=ts&"
export * from "./DropdownItemsList.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownItemsList.vue?vue&type=style&index=0&id=491d1b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d1b9a",
  null
  
)

export default component.exports